import React, { PureComponent, SyntheticEvent } from 'react';
import { Theme } from '@mui/material/styles';
import withTheme from '@mui/styles/withTheme';
import withStyles from '@mui/styles/withStyles';
import { DropMenu } from 'Common/components/Molecules/DropMenu';
import { Text } from 'Common/components/Atoms/Text';
import { FontIcon } from 'Common/components/Atoms/FontIcon';
import { IconDefinition } from '@fortawesome/fontawesome-svg-core';
import { faChevronUp, faChevronDown } from '@fortawesome/pro-solid-svg-icons';

export type Organization = {
  providerId: number;
  slug: string;
  name: string;
  photo_url: string;
  uuid: string;
  provider: string;
};

export type Item = {
  title: string;
  url: string;
  icon?: IconDefinition | null;
  iconAlign?: string;
  avatar?: boolean;
  imageUrl?: string;
  avatarTextBackground?: string;
  active?: boolean;
  onClick?: (e?: SyntheticEvent) => void;
  background?: string;
};

export interface Props {
  onClick: () => void;
  classes?: {
    container: string;
  };
  theme: Theme;
  items: Item[];
  title: string | JSX.Element;
  id: string;
  width?: number;
  footer?: Item;
}

const styles = (theme: Theme) => ({
  container: {
    cursor: 'pointer',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    height: '30px',
    '& svg': {
      marginLeft: '15px',
      color: theme.palette.text.secondary,
    },
    '&:hover svg': {
      color: theme.palette.text.primary,
    },
    '&:hover p': {
      color: theme.palette.info.main,
    },
  },
});

export class Selector extends PureComponent<Props> {
  state = {
    showDropdown: false,
    anchorEl: null,
  };

  handleClick = (event: SyntheticEvent) => {
    const { onClick } = this.props;
    const { showDropdown } = this.state;
    this.setState({
      showDropdown: !showDropdown,
      anchorEl: event.currentTarget,
    });
    onClick();
  };

  render(): JSX.Element {
    const { classes, items, title, id, width, footer, theme } = this.props;
    const { showDropdown, anchorEl } = this.state;

    return (
      <React.Fragment>
        <div className={classes?.container} onClick={this.handleClick}>
          <Text
            variant="h3"
            component="div"
            fontWeight={theme.typography.fontWeightRegular}
            color="textPrimary"
          >
            {title}
          </Text>
          <FontIcon icon={showDropdown ? faChevronUp : faChevronDown} ml={2} />
        </div>
        <DropMenu
          id={id}
          anchorEl={anchorEl}
          show={showDropdown}
          items={items}
          dismiss={() => this.setState({ showDropdown: false })}
          transformOrigin={{ vertical: -17, horizontal: 'left' }}
          width={width}
          footer={footer}
        />
      </React.Fragment>
    );
  }
}

export default withTheme(withStyles(styles)(Selector));
